import { Component } from '@angular/core';

@Component({
  selector: '[navbar]',
  templateUrl: './nav-bar.component.html'
})
export class NavBarComponent {
}
